export enum UserType {
    Regular = 'Regular',
    Admin = 'Admin'
}
